// extracted by mini-css-extract-plugin
export default {"LdsRing":"LdsRoller_LdsRing__vN8ws","pulse":"LdsRoller_pulse__QLAUd","scaleUp":"LdsRoller_scaleUp__Ws1QJ"};